/* eslint-disable react/jsx-filename-extension, react/jsx-sort-props, react/prop-types */
import React from 'react';
import r from 'render-dom';
import styled from 'styled-components';

const InlinePlayer = styled.div`
    padding:56.25% 0 0 0;
    position:relative;

    & div.wistia_responsive_wrapper {
        height:100%;
        left:0;
        position:absolute;
        top:0;
        width:100%;
    }

    & div.wistia_embed {
        height:100%;
        position:relative;
        width:100%;
    }

    & div.wistia_swatch {
        height:100%;
        left:0;
        opacity:1;
        overflow:hidden;
        position:absolute;
        top:0;
        transition:opacity 200ms;
        width:100%;
    }

    & img {
        filter:blur(5px);
        height:100%;
        object-fit:contain;
        width:100%;
    }
`;

const LinkPlayer = styled.div`
    width: fit-content;
    & * {
        cursor: pointer;
    }
`;

const ThumbnailPlayer = styled.div`
    margin-bottom: 40px;
    min-height: 300px;
    min-width: 300px;
`;

export default function WistiaVideoPlayer({
    className = '',
    children,
    showInline = false,
    showThumbnail = false,
    style = {},
    videoId,
}) {
    if (showInline) {
        return (
            <InlinePlayer className={ `wistia_responsive_padding ${className}` }>
                <div className="wistia_responsive_wrapper">
                    <div className={ `wistia_embed wistia_async_${videoId} videoFoam=true volume=0.6` }>
                        <div className="wistia_swatch">
                            <img
                                alt=""
                                aria-hidden="true"
                                src={ `https://fast.wistia.com/embed/medias/${videoId}/swatch` } />
                        </div>
                    </div>
                </div>
            </InlinePlayer>
        );
    }

    if (showThumbnail) {
        return (
            r(ThumbnailPlayer, {
                className: `wistia_embed wistia_async_${videoId} volume=0.6 popover=true popoverAnimateThumbnail=true ${className}`,
                showThumbnail,
            })
        );
    }

    return (
        r(LinkPlayer, {
            className: `wistia_embed wistia_async_${videoId} volume=0.6 popover=true popoverContent=link ${className}`,
            style
        }, [
            children,
        ])
    );
}
